// UIKit Components
import ErrorBox, { ErrorBoxProps } from '@components/ErrorBox';
import { FlexBoxProps } from '@spazious/react-components';

import ErrorRoute from '../ErrorRoute/index.js';

export type ErrorViewProps = FlexBoxProps & Partial<Pick<ErrorBoxProps, 'error'>>;

/**
 * Route error handler for error
 * @returns
 */
export const ErrorView: React.FC<ErrorViewProps> = ({ error }) => {
  if (error) {
    return <ErrorBox error={error} />;
  }

  return <ErrorRoute />;
};

export default ErrorView;
